import { render, staticRenderFns } from "./RelatorioPersonalizadoView.vue?vue&type=template&id=49ccfe08&scoped=true"
import script from "./RelatorioPersonalizadoView.vue?vue&type=script&lang=js"
export * from "./RelatorioPersonalizadoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ccfe08",
  null
  
)

export default component.exports